import { useApi } from "@/hooks/useApi";

import { transformData } from "@/utils/transformData";
import { paginatedProceduresMap } from "@/utils/mappings/paginatedProcedures";

import { Additional, ReactSelect, ReactSelectProps } from "../ReactSelect";

type Props = ReactSelectProps;

type TransformedPaginationProcedures = TransformedGenericPagination<Procedure>;

export function ProceduresSelect({ ...rest }: Props) {
	const { api } = useApi();

	async function handleGetProcedures(page?: number, search?: string) {
		try {
			const { data } = await api.get("/surgical-center/procedures", {
				params: {
					page: page || 1,
					search,
				},
			});

			const tranformedProcedures = transformData<TransformedPaginationProcedures>(
				data,
				paginatedProceduresMap
			);

			return tranformedProcedures;
		} catch (error) {
			console.log(error);
			return {} as TransformedPaginationProcedures;
		}
	}

	const loadAsyncProceduresOptionsProps = {
		additional: {
			page: 1,
		},
		isAsyncPaginate: true,
		async loadOptions(search: string, __: Procedure, { page }: Additional) {
			const procedures = await handleGetProcedures(page, search);

			return {
				options: procedures?.results.map((procedure) => ({
					value: procedure.code,
					label: `${procedure.code} - ${procedure.name}`,
				})),
				hasMore: procedures.meta?.currentPage < procedures.meta?.lastPage || false,
				additional: {
					page: page + 1,
				},
			};
		},
	};

	return <ReactSelect isSolid {...loadAsyncProceduresOptionsProps} {...rest} />;
}
